<template>
    <v-container class="product-registration-page">
        <v-overlay :absolute="true" :value="noOrgInfo">
            <org-overlay></org-overlay>
        </v-overlay>
        <base-hero-simple class="mb-2">
            <base-router-links :items="links" />
        </base-hero-simple>
        <div class="category-container-register">
            <div class="container-bg product-registration-container">
                <div class="container-fg">
                    <div class="product-registration-header">
                        <div class="product-registration-header-inner">
                            <div class="product-registration-logo-wrap">
                                <img class="product-registration-logo" src="../../../assets/logos/getac-logo.svg" />
                            </div>
                            <div class="product-registration-title-wrap">
                                <h1 class="product-registration-title">Product Registration</h1>
                            </div>
                        </div>
                    </div>
                    <div>
                        <v-card id="product-registration" elevation="0" dark color="transparent">
                            <div class="mobile-tab-selector-wrap mt-5">
                                <v-btn-toggle
                                    v-model="activeTab"
                                    class="mobile-tab-selector"
                                    color="primary"
                                    dense
                                    mandatory
                                >
                                    <v-btn class="mobile-tab-btn" small>
                                        <span class="text-overline nav-font">Register</span>
                                    </v-btn>
                                    <v-btn class="mobile-tab-btn" small>
                                        <span class="text-overline nav-font">Upload</span>
                                    </v-btn>
                                    <v-btn class="mobile-tab-btn" small>
                                        <span class="text-overline nav-font">Registered</span>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>

                            <v-tabs
                                v-model="activeTab"
                                class="request-tab-top product-registration-tabs"
                                dark
                                show-arrows
                            >
                                <v-tab dark>
                                    <div class="text-overline nav-font product-registration-tab-label">
                                        Register Serial
                                    </div>
                                </v-tab>
                                <v-tab dark>
                                    <div class="text-overline nav-font product-registration-tab-label">
                                        Upload File
                                    </div>
                                </v-tab>
                                <v-tab dark>
                                    <div class="text-overline nav-font product-registration-tab-label">
                                        List Registered Products
                                    </div>
                                </v-tab>

                                <v-tab-item
                                    class="product-registration-tab-pane"
                                    style="background-color: transparent !important"
                                >
                                    <register-serial-tab
                                        :user-is-org-admin="userIsOrgAdmin"
                                        :org-list="orgList"
                                        :serial-submit-loading="serialSubmitLoading"
                                        :successful-registrations="successfulRegistrations"
                                        :loading="$apollo.loading"
                                        @submit-serial="handleSubmitSerial"
                                    />
                                </v-tab-item>

                                <v-tab-item
                                    class="product-registration-tab-pane"
                                    style="background-color: transparent !important"
                                >
                                    <upload-file-tab
                                        :user-is-org-admin="userIsOrgAdmin"
                                        :org-list="orgList"
                                        :upload-loading="uploadLoading"
                                        :upload-file-name="uploadFileName"
                                        :uploaded-sns="uploadedSns"
                                        :loading="$apollo.loading"
                                        @upload-file="uploadSerialNumbers"
                                        @download-format-example="downloadFormatExample"
                                    />
                                </v-tab-item>

                                <v-tab-item
                                    class="product-registration-tab-pane"
                                    style="background-color: transparent !important"
                                >
                                    <list-registered-products-tab
                                        :org-list="orgList"
                                        :query-s-m-model="querySMModel"
                                        :registered-sns="registeredSns"
                                        :loading="$apollo.loading"
                                        :user-is-org-admin="userIsOrgAdmin"
                                        @list-registered="handleListRegistered"
                                        @export-current="exportCurrent"
                                        @delete-serial="deleteSerial"
                                        @move-serial="handleMoveSerial"
                                    />
                                </v-tab-item>
                            </v-tabs>
                        </v-card>
                    </div>
                </div>
            </div>
        </div>
        <v-snackbar v-model="snackbar">
            {{ snackbarMessage }}

            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" color="white" @click="snackbar = false"> Close </v-btn>
            </template>
        </v-snackbar>
        <v-dialog v-model="seedStock" max-width="600" :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card dark>
                <v-toolbar class="text-overline" dark>Seed Stock</v-toolbar>
                <v-card-text>
                    <div class="text-overline mt-5">Would you like seed stock?</div>
                    <v-alert dense type="info" color="grey darken-2">
                        <span
                            >After registering 150 in-warranty serials of the same model, you may request seed stock.
                            Seed stock is a one-time shipment that allows you to keep a small quantity of components at
                            your location for faster maintenance and repairs.
                        </span>
                    </v-alert>
                    <v-radio-group v-model="stockSelection" column>
                        <v-radio label="No, continue to product registration." :value="false"></v-radio>
                        <v-radio label="Yes (must confirm address & contact information)" :value="true"></v-radio>
                    </v-radio-group>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn outlined color="#db5120" @click="proceedStock(stockSelection)">Continue</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="confirmInfo" max-width="750" :fullscreen="$vuetify.breakpoint.xsOnly">
            <confirm-info @confirmed="infoConfirmed" @cancel="confirmInfo = false"></confirm-info>
        </v-dialog>
        <v-dialog v-model="seedStockView" max-width="450" :fullscreen="$vuetify.breakpoint.xsOnly">
            <seed-stock
                :confirmed-customer="confirmedCustomer"
                @submitted="stockSubmitted($event)"
                @errorSubmit="errorSubmit($event)"
            ></seed-stock>
        </v-dialog>
    </v-container>
</template>

<script>
import { navLinks } from '../navigation.js'
import gql from 'graphql-tag'
import { downloadJsonAsExcel, processExcel } from '@/utils/excel'
import serialsExample from './serials_example.js'
import OrgOverlay from '../../../components/no_org_overlay'
import ConfirmInfo from './confirm_info.vue'
import SeedStock from './seed_stock.vue'
import RegisterSerialTab from './tabs/register_serial.vue'
import UploadFileTab from './tabs/upload_file.vue'
import ListRegisteredProductsTab from './tabs/list_registered_products.vue'
import { verifySerialForRma } from '@/api'
import {
    mdiCheckboxMarkedCircleOutline,
    mdiAccountSupervisorCircle,
    mdiBarcode,
    mdiTag,
    mdiMapMarker,
    mdiArrowRightBoldCircle,
    mdiHistory,
    mdiCloudUploadOutline,
    mdiFileExcelOutline,
    mdiOfficeBuildingOutline,
    mdiFileDocumentOutline,
    mdiFileDownloadOutline
} from '@mdi/js'

export default {
    metaInfo: { title: `Your Account`, subTitle: `Account Settings` },
    name: `ProductRegistration`,
    components: {
        OrgOverlay,
        ConfirmInfo,
        SeedStock,
        RegisterSerialTab,
        UploadFileTab,
        ListRegisteredProductsTab
    },
    apollo: {
        querySMCustomer: {
            query: gql`
                query QuerySMCustomer($customerId: String!) {
                    querySMCustomer(customerId: $customerId) {
                        smConfirmed
                    }
                }
            `,
            variables() {
                return {
                    customerId: this.$auth.user.org.branchId
                }
            },
            update(data) {
                const isOrgUser = !!this.$auth.user.org
                if (data.querySMCustomer && !data.querySMCustomer.smConfirmed) {
                    this.seedStock = isOrgUser
                }
            }
        },
        queryOrg: {
            query: gql`
                query QueryOrg {
                    queryOrg {
                        gssOrgId
                        orgId
                        orgName
                    }
                }
            `,
            update(data) {
                if (!data.queryOrg) {
                    this.noOrgInfo = true
                }
                if (data.queryOrg.orgId && data.queryOrg.orgName) {
                    this.currentOrg = { orgId: data.queryOrg.orgId, organizationName: data.queryOrg.orgName }
                }
            }
        },
        resolveAccountOrganization: {
            query: gql`
                query ResolveAccountOrganization($resolveAccountOrganizationId: String) {
                    resolveAccountOrganization(id: $resolveAccountOrganizationId) {
                        orgId
                        organizationName
                        childrenOrg {
                            orgId
                            organizationName
                        }
                    }
                }
            `,
            skip() {
                return !this.currentOrg || !this.currentOrg.orgId
            },
            variables() {
                return {
                    resolveAccountOrganizationId: this.currentOrg.orgId
                }
            },
            update(data) {
                if (data.resolveAccountOrganization !== null) {
                    this.childrenOrgs = data.resolveAccountOrganization.childrenOrg
                    this.orgList = [this.currentOrg, ...this.childrenOrgs]
                }
            }
        },
        querySMModel: {
            query: gql`
                query querySMModel {
                    querySMModel {
                        model
                        iwQty
                        oowQty
                    }
                }
            `
        },
        queryRegisteredSNList: {
            query: gql`
                query QueryRegisteredSNList($customerId: String, $model: String) {
                    queryRegisteredSNList(customerId: $customerId, model: $model) {
                        sn
                        assetTag
                        location
                        inwarranty
                        registerDate
                        model
                        orgName
                        orgId
                    }
                }
            `,
            async update(data) {
                this.registeredSns = data.queryRegisteredSNList
            }
        }
    },
    data() {
        return {
            mdiHistory,
            mdiArrowRightBoldCircle,
            mdiMapMarker,
            mdiTag,
            mdiBarcode,
            mdiAccountSupervisorCircle,
            mdiCheckboxMarkedCircleOutline,
            mdiCloudUploadOutline,
            mdiFileExcelOutline,
            mdiOfficeBuildingOutline,
            mdiFileDocumentOutline,
            mdiFileDownloadOutline,
            snackbar: false,
            snackbarMessage: '',
            serialSubmitLoading: false,
            uploadLoading: false,
            uploadFileName: '',
            confirmedCustomer: null,
            seedStockView: false,
            askAgain: false,
            confirmInfo: false,
            stockSelection: false,
            seedStock: false,
            selectedOrg: '',
            noSNmessage: 'No serials selected',
            serialHeaders: [
                {
                    text: 'Selected Serial #',
                    value: 'sn',
                    align: 'left'
                }
            ],
            validSNs: false,
            orgList: [],
            dialog: false,
            selectedSNs: [],
            currentOrg: {},
            fromOrg: '',
            toOrg: '',
            childrenOrgs: [],
            links: navLinks,
            noOrgInfo: false,
            serialsExample,
            registeredSns: [],
            search: '',
            noItemsMessage: 'No registered serials found.',
            fileInput: null,
            uploadedSns: [],
            successfulRegistrations: [],
            modelsList: [],
            activeTab: 0
        }
    },
    computed: {
        userIsOrgAdmin() {
            return (
                this.$auth.user &&
                this.$auth.user.org &&
                this.$auth.user.org.adminUserIds &&
                this.$auth.user.org.adminUserIds.includes(this.$auth.user.id)
            )
        }
    },
    methods: {
        handleSubmitSerial(formData) {
            const { serialNumber, assetTag, location, registerSerialToOrg } = formData
            this.submitSerial(serialNumber, assetTag, location, registerSerialToOrg)
        },
        handleListRegistered(filterData) {
            const { selectedOrg, selectedModel } = filterData
            this.listRegistered(selectedOrg, selectedModel)
        },
        async handleMoveSerial(moveData) {
            const { selectedSNs, fromOrg, toOrg, onComplete } = moveData
            const success = await this.moveSerial(selectedSNs, fromOrg, toOrg)

            if (typeof onComplete === 'function') {
                onComplete(success)
            }
        },
        async verifySerial(serial, org, assetTag, location) {
            this.serialData = {}
            if (serial && serial.length >= 9) {
                this.callingApi = true
                try {
                    const normalizedSerial = serial.toUpperCase().trim()
                    const { data } = await verifySerialForRma({
                        serial: normalizedSerial
                    })

                    const serialData = data.constructor.name === `Object` ? data : {}

                    this.successfulRegistrations.push({
                        ...serialData,
                        org: org,
                        assetTag: assetTag,
                        location: location
                    })
                } catch (error) {
                    console.error(error)
                } finally {
                    this.callingApi = false
                }
            }
        },
        errorSubmit(error) {
            this.snackbar = true
            this.snackbarMessage = error
        },
        stockSubmitted(data) {
            this.seedStockView = !data.data.updateAccountOrganization.success
            this.snackbar = true
            this.snackbarMessage = !data.data.updateAccountOrganization.success
                ? data.data.updateAccountOrganization.error
                : 'Successfully submitted'
        },
        infoConfirmed(customer) {
            this.confirmedCustomer = customer
            this.confirmInfo = false
            this.seedStockView = true
        },
        proceedStock(viewStock) {
            this.seedStock = false
            if (viewStock) {
                this.confirmInfo = true
            } else {
                const input = {
                    smConfirmed: true,
                    confirmedCategories: []
                }
                this.$apollo.mutate({
                    mutation: gql`
                        mutation UpdateAccountOrganization($input: AccountOrganizationInput!, $orgId: String!) {
                            updateAccountOrganization(input: $input, orgId: $orgId) {
                                complete
                                error
                                success
                                uid
                            }
                        }
                    `,
                    variables: {
                        input: input,
                        orgId: this.$auth.user.org.branchId
                    }
                })
            }
        },
        downloadFormatExample() {
            const example = [
                {
                    SERIAL_NUMBER: null,
                    ASSET_TAG: null,
                    LOCATION: null
                }
            ]
            downloadJsonAsExcel(`SerialsUpload`, `Serials`, example)
        },
        deleteSerial(serial) {
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation DeregisterSNs($snList: [String!]!, $orgId: String) {
                            deregisterSNs(snList: $snList, orgId: $orgId)
                        }
                    `,
                    variables: {
                        snList: serial.sn,
                        orgId: serial.orgId
                    }
                })
                .then((data) => {
                    if (data.data.deregisterSNs === 'success') {
                        this.snackbar = true
                        this.snackbarMessage = `Serial #` + serial.sn + ` successfully deleted`
                        this.$apollo.queries.querySMModel.refetch({})
                        this.$apollo.queries.queryRegisteredSNList.refetch({})
                    } else {
                        this.snackbar = true
                        this.snackbarMessage = 'Error deleting serial #' + serial.sn + ': ' + data.data.deregisterSNs
                    }
                })
                .catch((error) => {
                    this.snackbar = true
                    this.snackbarMessage = 'Error deleting serial #' + serial.sn + ': ' + error
                })
        },
        async moveSerial(selectedSNs, fromOrg, toOrg) {
            let fromOrgId = fromOrg
            if (fromOrg && typeof fromOrg === 'object' && fromOrg.orgId) {
                fromOrgId = fromOrg.orgId
            }
            if (!(selectedSNs.length > 0 && fromOrgId && toOrg)) {
                return false
            }

            const snList = selectedSNs.map((e) => e.sn)
            const snString = snList.join(', ')

            try {
                const data = await this.$apollo.mutate({
                    mutation: gql`
                        mutation MoveSerialNumbers($serialNumbers: [String!]!, $toOrgId: String!, $fromOrgId: String!) {
                            moveSerialNumbers(serialNumbers: $serialNumbers, toOrgId: $toOrgId, fromOrgId: $fromOrgId) {
                                success
                                error
                            }
                        }
                    `,
                    variables: {
                        serialNumbers: snList,
                        toOrgId: toOrg,
                        fromOrgId: fromOrgId
                    }
                })

                if (data.data.moveSerialNumbers.success === true) {
                    this.snackbar = true
                    this.snackbarMessage = `Serial #` + snString + ` successfully moved`
                    this.selectedSNs = []
                    this.selectedOrg = ''
                    this.fromOrg = ''
                    this.toOrg = ''
                    this.search = ''
                    this.$apollo.queries.queryRegisteredSNList.refetch()
                    return true
                }

                this.snackbar = true
                this.snackbarMessage = `Error moving serial # ${snString}: ` + data.data.moveSerialNumbers.error
                return false
            } catch (error) {
                this.snackbar = true
                this.snackbarMessage = `Error moving serial # ${snList} : ` + error
                return false
            }
        },
        async submitSerial(serialNumber, assetTag, location, registerSerialToOrg) {
            if (!serialNumber || !serialNumber.trim()) {
                return
            }

            this.serialSubmitLoading = true
            try {
                const { data } = await this.$apollo.mutate({
                    mutation: gql`
                        mutation RegisterSNs($snList: [SNRegistrationEntry!]!, $orgId: String) {
                            registerSNs(snList: $snList, orgId: $orgId)
                        }
                    `,
                    variables: {
                        snList: [
                            {
                                sn: serialNumber.toUpperCase().trim(),
                                assetTag: assetTag.trim(),
                                location: location.trim()
                            }
                        ],
                        orgId: this.userIsOrgAdmin ? registerSerialToOrg.orgId : null
                    }
                })

                if (data.registerSNs === 'success') {
                    this.snackbar = true
                    this.snackbarMessage = `Serial #` + serialNumber + ` successfully registered`
                    const submittedOrgName =
                        this.userIsOrgAdmin && registerSerialToOrg
                            ? registerSerialToOrg.organizationName
                            : this.$auth.user && this.$auth.user.org
                            ? this.$auth.user.org.name
                            : ''
                    await this.verifySerial(serialNumber, submittedOrgName, assetTag.trim(), location.trim())
                    await Promise.all([
                        this.$apollo.queries.querySMModel.refetch({}),
                        this.$apollo.queries.queryRegisteredSNList.refetch({})
                    ])
                } else {
                    this.snackbar = true
                    this.snackbarMessage = `Error registering serial: ` + data.registerSNs
                }
            } catch (error) {
                this.snackbar = true
                this.snackbarMessage = `Error registering serial ${serialNumber}: ` + error
            } finally {
                this.serialSubmitLoading = false
            }
        },
        listRegistered(customerId, model) {
            this.registeredSns = []
            this.$apollo.queries.queryRegisteredSNList.refetch({ customerId: customerId, model: model })
        },
        exportCurrent() {
            downloadJsonAsExcel(
                `Registered Serials`,
                `Registered Serials`,
                this.registeredSns.map((e) => ({
                    Serial: e.sn,
                    Model: e.model,
                    Organization: e.orgName,
                    AssetTag: e.assetTag,
                    Location: e.location,
                    InWarranty: e.inwarranty,
                    RegisterDate: new Date(e.registerDate).toLocaleString()
                }))
            )
        },
        async confirmUploadedSerials(uploadSerialToOrg) {
            const uploadOrgId = this.userIsOrgAdmin && uploadSerialToOrg ? uploadSerialToOrg : null

            if (this.userIsOrgAdmin) {
                await this.adminSerialUpload(uploadOrgId)
            } else {
                await this.plainSerialUpload(uploadOrgId)
            }
        },
        snackbarConfirmation(message) {
            this.snackbar = true
            this.snackbarMessage = message
        },
        async plainSerialUpload(uploadOrgId) {
            await this.$apollo
                .mutate({
                    mutation: gql`
                        mutation RegisterSNs($snList: [SNRegistrationEntry!]!, $orgId: String) {
                            registerSNs(snList: $snList, orgId: $orgId)
                        }
                    `,
                    variables: {
                        snList: this.uploadedSns,
                        orgId: uploadOrgId
                    }
                })
                .then((data) => {
                    if (data.data.registerSNs === 'success') {
                        this.snackbarConfirmation(this.uploadedSns.length + ` serials successfully registered`)
                        this.$apollo.queries.querySMModel.fetchMore({})
                        this.$apollo.queries.queryRegisteredSNList.fetchMore({})
                    } else {
                        this.snackbarConfirmation('Error registering serials: ' + data.data.registerSNs)
                        this.uploadedSns = []
                    }
                })
                .catch(() => {
                    this.snackbarConfirmation('Error registering serials')
                    this.uploadedSns = []
                })
                .finally(() => {
                    this.uploadLoading = false
                })
        },
        async adminSerialUpload(uploadOrgId) {
            await this.$apollo
                .mutate({
                    mutation: gql`
                        mutation RegisterAndTransferExistingSns($snList: [SNRegistrationEntry!]!, $orgId: String) {
                            registerAndTransferExistingSns(snList: $snList, orgId: $orgId)
                        }
                    `,
                    variables: {
                        snList: this.uploadedSns,
                        orgId: uploadOrgId
                    }
                })
                .then((data) => {
                    if (data.data.registerAndTransferExistingSns === 'success') {
                        this.snackbarConfirmation(this.uploadedSns.length + ` serials successfully registered`)
                        this.$apollo.queries.querySMModel.fetchMore({})
                        this.$apollo.queries.queryRegisteredSNList.fetchMore({})
                    } else {
                        this.snackbarConfirmation(
                            'Error registering serials: ' + data.data.registerAndTransferExistingSns
                        )
                        this.uploadedSns = []
                    }
                })
                .catch(() => {
                    this.snackbarConfirmation('Error registering serials')
                    this.uploadedSns = []
                })
                .finally(() => {
                    this.uploadLoading = false
                })
        },
        uploadSerialNumbers(file, org) {
            if (file) {
                if (this.uploadLoading) {
                    this.snackbarConfirmation('Please select an organization before uploading serials.')
                    return
                }
                this.uploadedSns = []

                this.uploadLoading = true
                this.uploadFileName = file.name
                const reader = new FileReader()
                reader.onload = async (e) => {
                    try {
                        const processedExcelJson = JSON.parse(processExcel(e.target.result))

                        const inner = processedExcelJson[Object.keys(processedExcelJson)[0]]

                        inner.splice(0, 1)

                        const serials = inner.map((row) => ({
                            sn: row[0].toUpperCase(),
                            assetTag: row[1] ? row[1].toString() : ``,
                            location: row[2] ? row[2].toString() : ``
                        }))

                        this.uploadedSns = serials
                        await this.confirmUploadedSerials(org)
                        this.uploadLoading = false
                    } catch (error) {
                        this.snackbarConfirmation('Error reading file. Please double check your file and formatting.')
                        this.uploadedSns = []
                        this.uploadLoading = false
                    }
                }
                reader.onerror = () => {
                    this.uploadLoading = false
                    this.uploadedSns = []
                    this.snackbarConfirmation('Error reading upload file')
                }
                reader.readAsBinaryString(file)
            }
        }
    }
}
</script>

<style>
#product-registration .v-slide-group__content {
    gap: 6px;
    padding: 4px;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    background-image: linear-gradient(155deg, rgba(90, 90, 90, 0.35), rgba(255, 255, 255, 0.06));
    border-radius: 10px;
}
.v-tabs .request-tab-top .theme--dark {
    background-color: transparent !important;
}
.theme--dark.v-tabs > .v-tabs-bar {
    background-color: transparent;
}
.category-container-register .theme--light.v-tabs-items {
    background-color: transparent !important;
}

.product-registration-tab-pane {
    padding-top: 10px;
}

.product-registration-container {
    max-width: 1100px;
    margin: auto;
}

.product-registration-header {
    position: relative;
    margin-bottom: 14px;
}

.product-registration-header-inner {
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 14px 16px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 14px;
    background: linear-gradient(135deg, rgba(18, 18, 18, 0.78), rgba(56, 56, 56, 0.42));
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
}

.product-registration-logo-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 150px;
    padding: 8px 12px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.03);
}

.product-registration-logo {
    width: 130px;
    height: auto;
    margin-bottom: 0;
    flex-shrink: 0;
}

.product-registration-title-wrap {
    display: flex;
    align-items: center;
    min-height: 44px;
    position: relative;
    padding-bottom: 8px;
}

.product-registration-title-wrap::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    border-radius: 999px;
    background: linear-gradient(90deg, #db5120 0%, rgba(219, 81, 32, 0.2) 100%);
}

.product-registration-title {
    margin: 0;
    color: rgba(255, 255, 255, 0.92);
    font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: clamp(0.78rem, 0.92vw, 0.9rem);
    font-weight: 300;
    letter-spacing: 0.07em;
    line-height: 1.2;
    text-transform: uppercase;
}

.product-registration-tabs .v-tab {
    text-transform: none;
    min-width: 0;
    padding: 0 12px;
    letter-spacing: 0.08em;
    min-height: 40px;
    border-radius: 8px;
    transition: background-color 0.2s ease, color 0.2s ease;
}

.product-registration-tab-label {
    white-space: nowrap;
    text-align: center;
    font-size: 0.72rem;
}

.product-registration-tabs > .v-tabs-bar {
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 10px;
    overflow: hidden;
}

.product-registration-tabs .v-tabs-slider-wrapper,
.product-registration-tabs .v-tabs-slider {
    display: none !important;
}

.product-registration-tabs .v-tab--active {
    background: rgba(219, 81, 32, 0.22);
}

.mobile-tab-selector-wrap {
    display: none;
}

.mobile-tab-selector {
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 10px;
    overflow: hidden;
}

.mobile-tab-btn {
    flex: 1 1 0;
    min-width: 0 !important;
    letter-spacing: 0.06em;
}

@media (max-width: 959px) {
    .product-registration-header {
        margin-bottom: 10px;
    }

    .product-registration-header-inner {
        gap: 14px;
        padding: 12px 14px;
    }

    .product-registration-logo-wrap {
        min-width: 132px;
        padding: 8px 10px;
    }

    .product-registration-logo {
        width: 112px;
    }
}

@media (max-width: 600px) {
    .product-registration-tab-pane {
        padding-top: 6px;
    }

    .product-registration-page {
        padding-left: 8px;
        padding-right: 8px;
    }

    .product-registration-header {
        margin-bottom: 8px;
    }

    .product-registration-header-inner {
        width: 100%;
        gap: 10px;
        padding: 10px 12px;
        border-radius: 12px;
    }

    .product-registration-logo-wrap {
        min-width: 0;
        padding: 6px 8px;
        border-radius: 8px;
    }

    .product-registration-logo {
        width: 96px;
        margin-bottom: 0;
    }

    .product-registration-title {
        line-height: 1.2;
        font-size: 0.72rem;
        letter-spacing: 0.06em;
    }

    .product-registration-title-wrap {
        padding-bottom: 6px;
    }

    .product-registration-tabs {
        margin-top: 2px;
    }

    .mobile-tab-selector-wrap {
        display: block;
        margin-bottom: 10px;
    }

    .product-registration-tabs > .v-tabs-bar {
        display: none !important;
    }

    .product-registration-tabs .v-tab {
        padding: 0 10px;
        min-height: 42px;
        min-width: 118px;
    }

    .product-registration-tab-label {
        line-height: 1.2;
        white-space: nowrap;
        font-size: 0.68rem;
        letter-spacing: 0.06em;
    }
}
</style>
